import { useEffect } from "react";
import * as React from "react";

export const EquipmentDropdown = ({
  value,
  onChange,
  options,
  errorMessage,
  anchorId,
}: {
  value: string;
  onChange: Function;
  options: string[];
  errorMessage?: string;
  anchorId?: string;
}) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const dropdownRef = React.useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  useEffect(() => {
    const firstDiv = dropdownRef.current?.querySelector(".custom-dropdown-selected");

    if (errorMessage) {
      firstDiv?.classList.add("custom-dropdown-error");
    } else {
      firstDiv?.classList.remove("custom-dropdown-error");
    }
  }, [errorMessage]);
  return (
    <div className="custom-dropdown" id={anchorId} ref={dropdownRef}>
      <div
        className={`custom-dropdown-selected ${isOpen ? "open" : ""}`}
        onClick={() => setIsOpen(!isOpen)}
      >
        <span>{value || "Equipment"}</span>
        <span className="custom-dropdown-arrow">▾</span>
      </div>
      {errorMessage && <p className="error-message">{errorMessage}</p>}
      {isOpen && (
        <ul className="custom-dropdown-options">
          {options.map((option) => (
            <li
              key={option}
              className={`custom-dropdown-option ${value === option ? "selected" : ""}`}
              onClick={() => {
                onChange(option);
                setIsOpen(false);
              }}
            >
              {option}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
